/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITokenUpdate
 */
export interface APITokenUpdate {
    /**
     * 
     * @type {string}
     * @memberof APITokenUpdate
     */
    name: string;
}

export function APITokenUpdateFromJSON(json: any): APITokenUpdate {
    return APITokenUpdateFromJSONTyped(json, false);
}

export function APITokenUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITokenUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function APITokenUpdateToJSON(value?: APITokenUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


